import { ColorProps } from 'types';

// ==============================|| THEME 2 COLORS ||============================== //

const theme2: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#e4e7ec',
  primaryMain: '#203461',
  primaryDark: '#1c2f59',
  primary200: '#909ab0',
  primary800: '#132145',

  // secondary
  secondaryLight: '#fde8ef',
  secondaryMain: '#ec407a',
  secondaryDark: '#ea3a72',
  secondary200: '#f6a0bd',
  secondary800: '#e42a5d',

  // success
  successLight: '#e3f8e8',
  success200: '#8be09f',
  successMain: '#17c13e',
  successDark: '#14bb38',

  // error
  errorLight: '#e48784',
  errorMain: '#d9534f',
  errorDark: '#d54c48',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fdf5ea',
  warningMain: '#f0ad4e',
  warningDark: '#ec9c3d',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkBackground: '#0a0f23', // level 3
  darkPaper: '#030614', // level 4

  // dark 800 & 900
  darkLevel1: '#070e13', // level 1
  darkLevel2: '#12172f', // level 2

  // primary dark
  darkPrimaryLight: '#ecedf1',
  darkPrimaryMain: '#606d88',
  darkPrimaryDark: '#586580',
  darkPrimary200: '#b0b6c4',
  darkPrimary800: '#44506b',

  // secondary dark
  darkSecondaryLight: '#fde8ef',
  darkSecondaryMain: '#ec407a',
  darkSecondaryDark: '#ea3a72',
  darkSecondary200: '#f6a0bd',
  darkSecondary800: '#e42a5d',

  // text variants
  darkTextTitle: '#e4e8f7',
  darkTextPrimary: '#d5d9e9',
  darkTextSecondary: '#d8ddf0'
};

export default theme2;
